/// <amd-module name="Test/TestPlansLibrary/LibraryHub/Redux/TestPlansLibraryActions" />
import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";

export const TestPlansLibraryActions = {
    //dispatched to show the edit column options panel
    editColumnOptionFieldsClicked: () =>
        createAction(TestPlansLibraryActionsTypes.editColumnOptionFieldsClicked, {})
};

export const enum TestPlansLibraryActionsTypes {
    editColumnOptionFieldsClicked = "TestPlansLibrary/editColumnOptionFieldsClicked"
}

export type TestPlansLibraryActions = ActionsUnion<typeof TestPlansLibraryActions>;
